import { GInputFile } from 'tennders-common/form/components'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

const AddOrderDocument = ({
  type,
  id,
  title,
  handleUpload
}) => {
  const { refreshTransaction } = useTransactions()

  return (
    <>
      <div className="border-b pb-12 mb-12">
        <GInputFile
          next={(data) => {
            if (handleUpload) {
              handleUpload(id, data)
            } else {
              refreshTransaction(id)
            }
          }}
          url="/documents"
          params={{ transaction: id, type }}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-4" />
          <span className="text-underline">{title}</span>
        </GInputFile>
      </div>
    </>
  )
}
export default AddOrderDocument
